import * as yup from 'yup'

export class DocumentTypeDto {
  documentTypeGuid?: string = undefined
  documentTypeId?: number = undefined
  name?: string = undefined
  specialIdentifier?: string = undefined
  isOCR?: boolean = undefined
  allowReparse?: boolean = undefined
  keyField1Label?: string = undefined
  keyField2Label?: string = undefined
  keyField3Label?: string = undefined
  keyField4Label?: string = undefined
  keyField5Label?: string = undefined
  keyField6Label?: string = undefined
  helpfulInformation?: string = undefined
}

export const documentTypeValidationSchema = yup.object({
  name: yup.string().required('Name is required.'),
  specialIdentifier: yup.string().required('Special Identifier is required.'),
  isOcr: yup.boolean().required('Is OCR is required.')
})
